import React, { createContext, useEffect, useState } from "react";
import { createAxiosInstance } from "../api/axios";
import { ErrorContext } from "../context/ErrorContext";
import { useContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { setError, triggerSessionExpired } = useContext(ErrorContext);

  // Create axios instance (without Clerk token, uses localStorage)
  const axiosInstance = createAxiosInstance(null);

  const fetchSelf = async () => {
    // Check if we have a token in localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      setUser(null);
      return;
    }

    setLoading(true);
    try {
      const response = await axiosInstance.get('/self/');
      setUser(response.data);
    } catch(error) {
      console.error('Error fetching user data:', error.response?.data);
      // Don't alert on every error, just log it
      // alert(error.response?.data);
      if (error.response?.status === 401 || error.response?.status === 403) {
        // Check if we just received a fresh token from OAuth (within last 5 seconds)
        const freshTokenTime = sessionStorage.getItem('freshTokenReceived');
        const isFreshToken = freshTokenTime && (Date.now() - parseInt(freshTokenTime)) < 5000;
        
        if (isFreshToken) {
          // Don't clear the token or show expired modal for a fresh OAuth token
          // The token might need a moment to propagate, or there's a backend issue
          console.warn('Fresh OAuth token failed validation - not clearing token yet');
          setUser(null);
          // Clear the fresh token flag after one failed attempt
          sessionStorage.removeItem('freshTokenReceived');
        } else {
          // Token is invalid, clear it and show session expired modal
          localStorage.removeItem('token');
          setUser(null);
          // Show session expired modal instead of error snackbar (no error notification needed)
          if (triggerSessionExpired) {
            triggerSessionExpired();
          }
        }
        // Don't show error notification - the modal is enough
      } else {
        // Only show error notification for non-auth errors
        setError("Failed to load user data");
        setUser(null);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    // Fetch user data on mount if token exists
    fetchSelf();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AuthContext.Provider value={{ 
      user, 
      setUser, 
      loading, 
      // clerkUser, 
      // getToken, 
      axios: axiosInstance,
      refetchUser: fetchSelf // Add method to manually refetch user
    }}>
      {children}
    </AuthContext.Provider>
  );
};
